import React from 'react'
import ScheduleComponents from '../components/schedule'
import '../App.css';

const Schedule = () => {
    return (
        <div className="sidePadding">
            <ScheduleComponents></ScheduleComponents>
        </div>
    )
}

export default Schedule
